import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-onlinetutorial',
  templateUrl: './onlinetutorial.component.html',
  styleUrls: ['./onlinetutorial.component.css']
})
export class OnlinetutorialComponent implements OnInit {

  Submitted:boolean = false;
  BookTitleList=[];
  ChapterHeadingList=[];
  ChapterTopicList=[];
  SearchChapterHeadingList=[];
  SearchChapterTopicList=[];
  ChapterContentList=[];

  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

  
  Content: '';
  LearningModel = {   
    TutorialID:0,
    ClassSectionID: "",
    ClassID:0,
    SectionID:0,
    StaffID:0,
    TutorialHeading: '',
    YouTubeUrls: '',   
    IsActive: true,
    IsShared:false,
};

 
SearchModel = {    
  StaffID:0,
  ClassID:0,
  SectionID:0,
};




LearningTutorialList=[];
GetAllLearningTutorial() {
  this.spinnerService.show();
  this.learningservice.GetOnlineTutorial(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.LearningTutorialList = data.LearningTutorialList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};



ContentModel = {  
  TutorialResourceID:0,  
  TutorialID:0,
  ResourceType:'0',
  TutorialHeading: '',
  ResourcePath:'',
  IsShared:false, 
  Description:""
};
ClearResource(){
  this.ContentModel.TutorialResourceID=0;
  this.ContentModel.ResourceType='0';
  this.ContentModel.ResourcePath='';
  this.ContentModel.IsShared=false;
 
}
Description:any;
GetContent(item){
  this.ContentModel.TutorialResourceID=0;
  this.ContentModel.ResourceType='0';
  this.ContentModel.ResourcePath='';
  this.ContentModel.IsShared=false;
  this.ContentModel.TutorialID=item.TutorialID;
  this.Description=item.Description ;
  this.ContentModel.TutorialHeading=item.TutorialHeading;
  this.GetAllTutorialResource();
  
}



TutorialResourceList=[];
GetAllTutorialResource() {
  this.spinnerService.show();
  this.learningservice.GetAllTutorialResource(JSON.stringify(this.ContentModel)).subscribe((data: any) => {
    this.TutorialResourceList = data.TutorialResourceList;

    if(this.TutorialResourceList){
      for (var i = 0; i < this.TutorialResourceList.length; i++) {
          let stringToSplit = this.TutorialResourceList[i].ResourcePath;  
    let x = stringToSplit.split("https://www.youtube.com/watch?v=");
    var safeSrc="https://www.youtube.com/embed/"+x[1]+"?loop=1"+"&origin=1&rel=1&showinfo=1"
    
   this.TutorialResourceList[i].ResourcePath=this._sanitizer.bypassSecurityTrustResourceUrl(safeSrc); 
  
              }
     
     }
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};


// embedURL(url){
//   return this._sanitizer.bypassSecurityTrustResourceUrl(url);

  
 
// }


  ngOnInit() {
  
    this.GetAllLearningTutorial();
  }

 

 

 

}
